import { Selector } from "@ngxs/store";
import { SpinnerState, SpinnerStateModel } from "./spinner.state";

export class SpinnerSelectors {
    @Selector([SpinnerState])
    static isLoading(state: SpinnerStateModel) {
        return state.isLoading;
    }

    @Selector([SpinnerState])
    static progress(state: SpinnerStateModel) {
        return state.progress;
    }
}